// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"a00a2f65","495":"03bf95ae"}[chunkId] + ".chunk.css";
};